import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useMemo } from "react";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import { applyValue, setNewOptions } from "../../lib";
import type { ActiveSubMenuState, SetActiveSubMenu } from "../../types";
import { SubMenu } from "../SubMenu/SubMenu";
import { StickerColorMenuContent } from "./StickerColorMenuContent";

interface StickerColorMenuProps {
    activeSubMenu: ActiveSubMenuState;
    setActiveSubMenu: SetActiveSubMenu;
}

export function StickerColorMenu({ activeSubMenu, setActiveSubMenu }: StickerColorMenuProps) {
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);
    const colorOptions = useAtomValue(widgetMenuOptionsByNameAtom("stickerColor"));

    const selectedColors = useMemo(() => {
        return Array.from(new Set(colorOptions.map((o) => String(o.value))));
    }, [colorOptions]);

    const handleButtonClick = useCallback(
        (value: string) => {
            const setNewStickerColorOptions = setNewOptions({
                name: "stickerColor",
                setWidgetMenuOptions,
            });

            function handleClose() {
                setActiveSubMenu(null);
            }

            applyValue({
                options: colorOptions,
                value,
                setNewOptions: setNewStickerColorOptions,
                handleClose,
            });
        },
        [colorOptions, setActiveSubMenu, setWidgetMenuOptions],
    );

    return (
        <SubMenu padding={8} activeSubMenu={activeSubMenu}>
            <StickerColorMenuContent
                selectedColors={selectedColors}
                onColorClick={handleButtonClick}
            />
        </SubMenu>
    );
}
